module.exports = __webpack_public_path__ + "img/open.07be9293.gif";